<script setup lang="ts">
import lodashLowerCase from 'lodash-es/lowerCase';

import { AUTOCOMPLETE_OFF } from '~/constants/form';

// PROPS
const { countryCode } = defineProps({
    countryCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
});

// COMPOSABLES
const { countries } = useCountries();
const { tt } = useTypedI18n();

// MODEL
const model = defineModel<string>({ default: '' });
const selectModel = ref<CountryOption | undefined>(countries.value.find(c => c.rootIddCode === model.value.split(' ')[0]));
const inputModel = ref<string>(model.value.split(' ')[1] ?? '');

// WATCHERS
watch(
    () => countryCode,
    () => {
        if (countryCode && countries.value.length > 0 && !inputModel.value) {
            const optionMatch = countries.value.find(c => c.countryCode === countryCode);

            if (optionMatch) {
                selectModel.value = optionMatch;
            }
        }
    },
    { immediate: true }
);

// HANDLERS
const onChange = (): void => {
    model.value = inputModel.value ? [parseRootIddCode(selectModel.value?.rootIddCode), inputModel.value].join(' ').trim() : '';
};

const parseRootIddCode = (rootIddCode?: string): string => {
    if (!rootIddCode || rootIddCode === 'undefined') return '';

    return rootIddCode;
};
</script>

<template>
    <div class="flex gap-1">
        <USelectMenu
            v-model="selectModel"
            :items="countries"
            :filter-fields="['rootIddCode']"
            :ui="{
                base: 'w-[136px]',
                focusScope: 'w-[124px]',
            }"
            :search-input="{ placeholder: tt('common.searchPlaceholder') }"
            :disabled="disabled"
            @update:model-value="onChange"
        >
            <template #leading>
                <UIcon v-if="selectModel" class="text-md" :name="`i-circle-flags-${lodashLowerCase(selectModel.countryCode)}`" />
            </template>
            <template #item="{ item }">
                <UIcon class="text-md" :name="`i-circle-flags-${lodashLowerCase(item.countryCode)}`" />
                {{ parseRootIddCode(item.rootIddCode) }}
            </template>
            {{ parseRootIddCode(selectModel?.rootIddCode) }}
        </USelectMenu>
        <UInput v-model="inputModel" :disabled="disabled" :autocomplete="AUTOCOMPLETE_OFF" @update:model-value="onChange" />
    </div>
</template>
